module.exports = __webpack_public_path__ + "static/media/saturn.82d6888f.svg";